import { createStore, useStore as useVuexStore, Store } from 'vuex'

import login from './login/login'
import websocket from './websocket/websocket'

import { IRootState, ISimTaskWorkInfo, IStoreType } from './type'

const store = createStore<IRootState>({
  state: () => {
    return {
      name: 'coder why',
      mainLoading: false,
      configCheckValue: '',
      simModelWorkLoading: false,
      simTaskWorkLoading: false,
      simTaskWorkInfo: {
        id: '',
        jobId: '',
        jobType: '',
        jobTypeName: '',
        status: '',
        jobProgress: 0,
        runDetails: {
          'Information / Errors / Warnings': '',
          Progress: {
            Simulation: 0,
            Setup: 0
          },
          Messages: '',
          'Process Monitor': ''
        }
      }
    }
  },
  mutations: {
    setMainLoading(state, value: boolean) {
      state.mainLoading = value
    },
    setConfigCheckValue(state, value: string) {
      state.configCheckValue = value
    },
    setSimModelWorkLoading(state, value: boolean) {
      state.simModelWorkLoading = value
    },
    setSimTaskWorkLoading(state, value: boolean) {
      state.simTaskWorkLoading = value
    },
    setSimTaskWorkInfo(state, value: ISimTaskWorkInfo) {
      state.simTaskWorkInfo = value
    }
  },
  actions: {},
  modules: {
    login,
    websocket
  }
})

export function setupStore() {
  store.dispatch('login/loadLocalLogin')
}

export function useStore(): Store<IStoreType> {
  return useVuexStore()
}

export default store
